import React, { useEffect } from 'react';
import { Form, Modal, ModalProps } from 'antd';
import {
  WorkOrderItem,
  WorkOrderItemOrigin,
  WorkOrderItemStockStatus,
  WorkOrderItemType,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import ReplicateComplementUpdateItemForm from './ReplicateComplementUpdateItemForm';
import { WorkOrderItemTag } from '@/core/domain/workorder/WorkOrderItemTags/WorkOrderItemTags.types';

export interface ComplementReplicateItemFormData {
  id: number;
  itemId: number;
  itemName?: string;
  manufacturingCode?: string;
  subAreaId?: number;
  manufacturerId?: number;
  supplierId: number;
  tag: Omit<WorkOrderItemTag, 'description'> & { name: string };
  isInternal: string;
  isInternalStock: boolean;
  quantity: number;
  unitPrice: number;
  discount: number;
  discountValue: number;
  unitCost: number;
  isPaintedPart: string;
  time?: number;
  type: WorkOrderItemType;
  status: WorkOrderItemStockStatus;
  origin: WorkOrderItemOrigin;
  configDiscount?: number;
}

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: () => void;
  complementItemSelected?: WorkOrderItem;
  onCallback: (values: ComplementReplicateItemFormData) => void;
}

const ReplicateComplementUpdateItemModal: React.FC<Props> = ({
  onCancel,
  complementItemSelected,
  onCallback,
  ...props
}) => {
  const [form] = Form.useForm<ComplementReplicateItemFormData>();

  useEffect(() => {
    if (complementItemSelected && props.open) {
      form.setFieldsValue({
        ...complementItemSelected,
        manufacturerId: complementItemSelected?.manufacturer?.id,
        itemName: complementItemSelected.description,
        subAreaId: complementItemSelected?.subArea?.id,
        supplierId: complementItemSelected?.supplier?.id,
        discount: complementItemSelected.discount * 100,
        discountValue:
          complementItemSelected.unitPrice *
          complementItemSelected.quantity *
          complementItemSelected.discount,
        isInternal: String(complementItemSelected.isInternal),
        type: complementItemSelected.type,
        isPaintedPart:
          complementItemSelected.isPaintedPart === null
            ? String(false)
            : String(complementItemSelected.isPaintedPart),
      });
    }
  }, [props.open]);

  const handleCancel = () => {
    onCancel();

    form.resetFields();
  };

  const handleOk = async () => {
    const values = await form.validateFields();

    onCallback(values);

    handleCancel();
  };

  return (
    <Modal
      {...props}
      width="60%"
      title="Edição do Item"
      onCancel={handleCancel}
      okText="Editar"
      onOk={handleOk}
    >
      <ReplicateComplementUpdateItemForm form={form} />
    </Modal>
  );
};

export default ReplicateComplementUpdateItemModal;
